<template>
	<v-navigation-drawer
		v-if="$vuetify.display.mdAndDown"
		v-model="navDrawer"
		sticky
		location="left"
		style="max-height: 100vh"
	>
		<div
			class="d-flex flex-column justify-space-between pa-4"
			style="height: 100%"
		>
			<div class="d-flex flex-column ga-4">
				<router-link to="/">
					<!-- eslint-disable-next-line vue/html-self-closing -->
					<img
						src="/assets/spclogo.webp"
						alt="ShootPro Cloud Logo"
						:height="$vuetify.display.mdAndDown ? '30px' : '50px'"
						class="mb-5"
					/>
				</router-link>
				<v-btn
					to="/"
					text="home"
					prepend-icon="mdi-home"
					variant="elevated"
					exact
				/>
				<v-btn
					v-for="link in links"
					:key="link.to"
					:to="link.to"
					:text="link.text"
					variant="elevated"
					exact
				/>
				<v-btn
					class="mt-12"
					href="https://club.shootpro.cloud/login"
					variant="text"
				>
					Club Login
				</v-btn>
			</div>
			<v-btn
				:to="primaryActionLink.to"
				variant="elevated"
				color="#F15B2A"
				size="default"
			>
				<span class="pa-1"> {{ primaryActionLink.text }} </span>
			</v-btn>
		</div>
	</v-navigation-drawer>
	<v-layout
		id="landers-layout"
		:class="{
			'bg-white': !isColoredBackground,
			'bg-cover': isColoredBackground,
		}"
	>
		<!-- absolute -->
		<v-app-bar>
			<v-container
				class="d-flex justify-space-between align-center flex-row"
				fluid
			>
				<v-icon class="d-flex d-md-none" @click="navDrawer = !navDrawer">
					mdi-menu
				</v-icon>

				<router-link to="/">
					<!-- eslint-disable-next-line vue/html-self-closing -->
					<img
						src="/assets/spclogo.webp"
						alt="ShootPro Cloud Logo"
						:height="$vuetify.display.smAndDown ? '30px' : '50px'"
					/>
				</router-link>

				<div
					id="nav-links-container"
					class="flex-row justify-end align-center d-none d-md-flex"
				>
					<v-btn
						v-for="link in links"
						:key="link.to"
						:to="link.to"
						:text="link.text"
						variant="text"
					/>
					<v-btn
						:to="primaryActionLink.to"
						variant="elevated"
						color="#F15B2A"
						size="default"
						class="ml-2"
					>
						<span class="pa-1"> {{ primaryActionLink.text }} </span>
					</v-btn>
				</div>
				<p class="d-flex d-md-none" />
			</v-container>
		</v-app-bar>
		<v-main
			:class="`mx-auto ${
				$route.meta.fullWidth || $vuetify.display.width <= 1140 ? '' : ''
			}`"
		>
			<v-container
				v-if="!hasSignedInBefore && $route.path.includes('/view/')"
				class="mb-n5"
			>
				<v-alert theme="dark" rounded class="mx-1">
					<div
						class="d-flex flex-row align-center justify-space-between"
						style="width: 100%"
					>
						<p v-once class="text-h6">
							Get more out of ShootPro Cloud by creating an account!
						</p>
						<v-btn to="/signup" color="#F15B2A" size="large"> Sign Up! </v-btn>
					</div>
				</v-alert>
			</v-container>
			<slot />
		</v-main>
	</v-layout>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import { authorizationStore as useAuthorizationStore } from '@/store/authorization';
import { computed, ref, watch, nextTick } from 'vue';
import $localStorage from '@/capacitor/localStorageWrapper';

const router = useRouter();
const route = useRoute();
const authorizationStore = useAuthorizationStore();

const user = computed(() => authorizationStore.user);
const navDrawer = ref(false);
const links = ref([
	{
		to: '/about',
		text: 'About',
	},
	{
		to: '/features',
		text: 'Features',
	},
	{
		to: '/for-shooters',
		text: 'For Shooters',
	},
	{
		to: '/for-clubs',
		text: 'For Clubs',
	},
	{
		to: '/view/shoots',
		text: 'Results',
	},
]);

const hasSignedInBefore = ref(false);
const primaryActionLink = ref({
	text: 'Sign Up',
	to: '/signup',
});
$localStorage.get('hasSuccessfulLogin').then((res) => {
	if (res) {
		primaryActionLink.value.text = 'Login';
		primaryActionLink.value.to = '/login';
		hasSignedInBefore.value = true;
	} else {
		hasSignedInBefore.value = false;
	}
});

const $route = useRoute();
watch(
	() => {
		return $route.meta?.imageBackground;
	},
	(v) => {
		if (v) {
			nextTick(() => {
				const landersLayout = document.getElementById('landers-layout');
				if (landersLayout) {
					landersLayout.style.background = "url('/assets/bg.webp')";
					landersLayout.style.backgroundSize = 'cover';
				}
			});
		}
	},
	{
		immediate: true,
	}
);

const isColoredBackground = computed(() => {
	return (
		route.path.includes('/view') || (route.meta.public && !route.meta.lander)
	);
});
</script>

<style scoped>
@media (min-width: 1441px) {
	.limitMaxWidth {
		max-width: 1440px;
		/* box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%),
			0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%); */
	}
}
.bg-cover {
	background: url('/assets/bg.webp');
	background-size: cover;
}
.bg-white {
	background: var(--v-theme-background) !important;
	background-size: cover;
}
</style>
style
